import { render, staticRenderFns } from "./DriversSearch.vue?vue&type=template&id=1f2ac54b&"
import script from "./DriversSearch.vue?vue&type=script&lang=js&"
export * from "./DriversSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports